export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70f1c50bf7ecb9f2f5fdd34d0eac36a06155a5b519&name=pushAdClickData!'